import { createRouter, createWebHashHistory } from 'vue-router';
import messages_i18n from '../src/assets/i18n/langs/i18n'
import { useI18n } from "vue-i18n";
import i18n from '../src/assets/i18n/langs/i18n';

const routes = [
  {
    name: 'notFound',
    path: '/:path(.*)+',
    redirect: {
      name: 'help',
    },
  },
  {
    name: 'help',
    path: '/help',
    component: () => import('./view/help'),
    meta: {
      //  title: useI18n('HelpCenterTitle'),
      title: 'message.HelpCenterTitle',
    }
  },
  {
    name: 'firmware_upgrade',
    path: '/firmware_upgrade',
    component: () => import('./view/Feeder/firmware_upgrade'),
    meta: {
      //  title: useI18n('HelpCenterTitle'),
      title: 'message.HelpCenterTitle',
    },
  },
  {
    name: 'condition',
    path: '/condition',
    component: () => import('./view/condition'),
    meta: {
      title: 'message.TermOfServiceTitle',
      // title: 'Terms of Service',
    },
  },
  {
    name: 'privacy',
    path: '/privacy',
    component: () => import('./view/privacy'),
    meta: {
       title: 'message.PrivacyPolicyTitle',
      // title: 'Privacy Policy',
    },
  },
  {
    name: 'bt_connect_fail',
    path: '/bt_connect_fail',
    component: () => import('./view/Feeder/bt_connect_fail'),
    meta: {
      title: 'message.HelpCenterTitle',
      // title: 'Bluetooth Connection Failure',
    },
  },
  {
    name: 'pet_nearby',
    path: '/pet_nearby',
    component: () => import('./view/iPetBox/pet_nearby'),
    meta: {
      title: 'message.HelpCenterTitle',
      // title: 'Bluetooth Connection Failure',
    },
  },
  {
    name: 'shovel_doing',
    path: '/shovel_doing',
    component: () => import('./view/iPetBox/shovel_doing'),
    meta: {
      title: 'message.HelpCenterTitle',
      // title: 'Bluetooth Connection Failure',
    },
  },
  {
    name: 'trash_full',
    path: '/trash_full',
    component: () => import('./view/iPetBox/trash_full'),
    meta: {
      title: 'message.HelpCenterTitle',
      // title: 'Bluetooth Connection Failure',
    },
  },
  {
    name: 'device_disconnect',
    path: '/device_disconnect',
    component: () => import('./view/Feeder/device_disconnect'),
    meta: {
       title: 'message.HelpCenterTitle',
      // title: 'Device Offline',
    },
  },
  {
    name: 'device_exception',
    path: '/device_exception',
    component: () => import('./view/Feeder/device_exception'),
    meta: {
       title: 'message.HelpCenterTitle',
      // title: 'Device Exception',
    },
  },
  {
    name: 'device_food_state',
    path: '/device_food_state',
    component: () => import('./view/Feeder/device_food_state'),
    meta: {
      title: 'message.HelpCenterTitle',
      // title: 'Food Jam',
    },
  },
  {
    name: 'sensor_introduction_video',
    path: '/sensor_introduction_video',
    component: () => import('./view/iPetBox/sensor_introduction_video'),
    meta: {
      title: 'message.HelpCenterTitle',
      // title: 'Food Jam',
    },
  },
  {
    name: 'installation_trash_bags',
    path: '/installation_trash_bags',
    component: () => import('./view/iPetBox/installation_trash_bags'),
    meta: {
      title: 'message.HelpCenterTitle',
      // title: 'Food Jam',
    },
  },
  {
    name: 'sieve_plate_install',
    path: '/sieve_plate_install',
    component: () => import('./view/iPetBox/sieve_plate_install'),
    meta: {
      title: 'message.HelpCenterTitle',
      // title: 'Food Jam',
    },
  },
  {
    name: 'wifi_connect_fail',
    path: '/wifi_connect_fail',
    component: () => import('./view/Feeder/wifi_connect_fail'),
    meta: {
      title: 'message.HelpCenterTitle',
      // title: 'WiFi Connection Failure',
    },
  },
  {
    name: 'about',
    path: '/about',
    component: () => import('./view/about'),
    meta: {
      title: 'message.AboutTitle',
      // title: 'About US',
    },
  },
  {
    name: 'feeder_pdf',
    path: '/feeder_pdf',
    component: () => import('./view/Feeder/pdf_doc'),
    meta: {
      title: 'message.PDF',
      title: 'PDF',
    },
  },
  {
    name: '5g_to_2.4g',
    path: '/5g_to_2.4g',
    component: () => import('./view/iPetBox/5Gconvert'),
    meta: {
      title: 'message.ConvertTitle1',
      // title: 'Convert',
    },
  },
  {
    name: 'wifiHidden',
    path: '/wifiHidden',
    component: () => import('./view/iPetBox/5Gconvert/wifiHidden'),
    meta: {
      title: 'message.WiFiConnectFailTitle1',
      // title: 'Convert',
    },
  },
  {
    name: 'wifiWeak',
    path: '/wifiWeak',
    component: () => import('./view/iPetBox/5Gconvert/wifiWeak'),
    meta: {
      title: 'message.WiFiConnectFailTitle2',
      // title: 'Convert',
    },
  },
  {
    name: '5GHz',
    path: '/5GHz',
    component: () => import('./view/iPetBox/5Gconvert/5GHz'),
    meta: {
      title: 'message.WiFiConnectFailTitle3',
      // title: 'Convert',
    },
  },
  {
    name: 'asusRouter',
    path: '/asusRouter',
    component: () => import('./view/iPetBox/5Gconvert/5GHz/asus'),
    meta: {
      title: 'Configure an ASUS router',
      // title: 'Convert',
    },
  },
  {
    name: 'netgearRouter',
    path: '/netgearRouter',
    component: () => import('./view/iPetBox/5Gconvert/5GHz/netgear'),
    meta: {
      title: 'Configure a Netgear router',
      // title: 'Convert',
    },
  },
  {
    name: 'tp-linkRouter',
    path: '/tp-linkRouter',
    component: () => import('./view/iPetBox/5Gconvert/5GHz/tp-link'),
    meta: {
      title: 'Configure a TP-Link router',
      // title: 'Convert',
    },
  },
  {
    name: 'd-linkRouter',
    path: '/d-linkRouter',
    component: () => import('./view/iPetBox/5Gconvert/5GHz/d-link'),
    meta: {
      title: 'Configure a D-Link router',
      // title: 'Convert',
    },
  },
  {
    name: 'iPetBox_pdf',
    path: '/iPetBox_pdf',
    component: () => import('./view/iPetBox/pdf_doc'),
    meta: {
      title: 'message.PDF',
      // title: 'PDF',
    },
  }, 
  {
    name: 'how_old_pet',
    path: '/how_old_pet',
    component: () => import('./view/iPetBox/how_old_pet'),
    meta: {
      title: 'message.HelpCenterTitle',
      // title: 'At which age can cats use this product? ',
    },
  },   
  {
    name: 'why_not_use',
    path: '/why_not_use',
    component: () => import('./view/iPetBox/why_not_use'),
    meta: {
      title: 'message.HelpCenterTitle',
      // title: 'What if the cat doesn´t want to use the new litter box? ',
    },
  },
  {
    name: 'what_types_litter',
    path: '/what_types_litter',
    component: () => import('./view/iPetBox/what_types_litter'),
    meta: {
      title: 'message.HelpCenterTitle',
      // title: 'What types of cat litter can I use?',
    },
  },  
  {
    name: 'how_much_add',
    path: '/how_much_add',
    component: () => import('./view/iPetBox/how_much_add'),
    meta: {
      title: 'message.HelpCenterTitle',
      // title: 'How much cat litter should I add?',
    },
  },
  {
    name: 'why_powerd_run',
    path: '/why_powerd_run',
    component: () => import('./view/iPetBox/why_powerd_run'),
    meta: {
      title: 'message.HelpCenterTitle',
      // title: 'Why did the device start running since it was powered on?',
    },
  },  
  {
    name: 'why_redlight_stop',
    path: '/why_redlight_stop',
    component: () => import('./view/iPetBox/why_redlight_stop'),
    meta: {
      title: 'message.WhyRedLightStopTitle',
      // title: 'Why does the device suddenly stop spinning and flashes red light while in operation?',
    },
  },
  {
    name: 'why_notfull_light',
    path: '/why_notfull_light',
    component: () => import('./view/iPetBox/why_notfull_light'),
    meta: {
      title: 'message.WhyNotFullLightTitle',
      // title: 'The litter collection bin is not full but the indicator light and the App remind it is full.',
    },
  },
  
];

const router = createRouter({
  routes,
  history: createWebHashHistory(),
});

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = i18n.global.t(title);
  }
  next();
});

export { router };
